import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { Observable, switchMap } from 'rxjs';
import { GraphUserProfile } from '../../../models/graph-user-profile.model';

@Injectable({
  providedIn: 'root',
})
export class GraphUserService {
  private http = inject(HttpClient);
  private msalService = inject(MsalService);
  graphUser = signal<any>(null);

  getGraphToken(): Observable<string> {
    return this.msalService
      .acquireTokenSilent({
        scopes: [environment.msalConfig.graphScope],
      })
      .pipe(
        switchMap((graphToken) => {
          if (graphToken) {
            return [graphToken.accessToken];
          } else {
            throw new Error('No token found. User may not be logged in.');
          }
        })
      );
  }

  getUserProfile(): Observable<any> {
    return this.getGraphToken().pipe(
      switchMap((accessToken) => {
        return this.http.get<any>(`${environment.msalConfig.graphUri}me`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
      })
    );
  }
}
